import React from 'react'

const Discourse = () => (
  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M20.17 0C9.223 0 0 8.795 0 19.652L.01 40l20.16-.018C31.126 39.982 40 30.848 40 19.992 40 9.133 31.125 0 20.17 0zM20 31.429c-1.732 0-3.384-.384-4.857-1.08l-7.241 1.794 2.044-6.696A11.412 11.412 0 0 1 8.571 20c0-6.312 5.117-11.429 11.43-11.429 6.312 0 11.428 5.117 11.428 11.429 0 6.313-5.116 11.429-11.429 11.429z" className="fill-current" fillRule="nonzero"/></svg>
)

export default Discourse
